import React, { useState } from 'react';
import LocationMapModal from '../../LocationMapModal';

const TrailerLocationReport = ({ locationData, theme }) => {
    const [showMap, setShowMap] = useState(false);
    
    const isLightTheme = theme === 'light';
    
    if (!locationData) {
        return null;
    }

    if (locationData.error || !locationData.location) {
        return (
            <div style={{
                padding: '40px',
                textAlign: 'center',
                backgroundColor: isLightTheme ? '#f8f9fa' : '#2a2a2a',
                border: `1px solid ${isLightTheme ? '#ddd' : '#555'}`,
                borderRadius: '8px',
                margin: '20px 0'
            }}>
                <h4 style={{ color: isLightTheme ? '#333' : '#fff', marginBottom: '20px' }}>
                    🚛 Trailer Location Not Found
                </h4>
                <div style={{
                    padding: '20px',
                    backgroundColor: isLightTheme ? '#fff3cd' : '#3d3d00',
                    border: `1px solid ${isLightTheme ? '#ffeaa7' : '#666600'}`,
                    borderRadius: '6px',
                    color: isLightTheme ? '#856404' : '#ffff99'
                }}>
                    <p style={{ margin: 0, fontSize: '16px' }}>
                        {locationData.error || 'No drop location records found for this trailer.'}
                    </p>
                    <p style={{ margin: '10px 0 0 0', fontSize: '14px', opacity: 0.8 }}>
                        This could mean the trailer hasn't been dropped yet or the drop wasn't recorded with location data.
                    </p>
                </div>
            </div>
        );
    }

    const { location, trailer_reg, drop_date, drop_time } = locationData;
    
    const handleViewMap = () => {
        setShowMap(true);
    };

    return (
        <div style={{
            backgroundColor: isLightTheme ? '#fff' : '#1a1a1a',
            border: `1px solid ${isLightTheme ? '#ddd' : '#555'}`,
            borderRadius: '8px',
            margin: '20px 0',
            overflow: 'hidden'
        }}>
            {/* Header */}
            <div style={{
                backgroundColor: isLightTheme ? '#007bff' : '#0056b3',
                color: '#fff',
                padding: '20px',
                textAlign: 'center'
            }}>
                <h4 style={{ margin: 0, fontSize: '24px' }}>
                    🚛 {trailer_reg} - Last Known Location
                </h4>
            </div>

            {/* Location Details */}
            <div style={{ padding: '30px' }}>
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                    gap: '20px',
                    marginBottom: '30px'
                }}>
                    <div style={{
                        padding: '20px',
                        backgroundColor: isLightTheme ? '#f8f9fa' : '#2a2a2a',
                        border: `1px solid ${isLightTheme ? '#e9ecef' : '#444'}`,
                        borderRadius: '6px'
                    }}>
                        <h6 style={{ 
                            color: isLightTheme ? '#666' : '#ccc', 
                            margin: '0 0 10px 0',
                            fontSize: '14px',
                            fontWeight: 'bold'
                        }}>
                            DROP DATE & TIME
                        </h6>
                        <div style={{ 
                            color: isLightTheme ? '#333' : '#fff',
                            fontSize: '16px',
                            fontWeight: '600'
                        }}>
                            {new Date(drop_date).toLocaleDateString('en-GB')}
                        </div>
                        <div style={{ 
                            color: isLightTheme ? '#666' : '#ccc',
                            fontSize: '14px'
                        }}>
                            {drop_time}
                        </div>
                    </div>

                    <div style={{
                        padding: '20px',
                        backgroundColor: isLightTheme ? '#f8f9fa' : '#2a2a2a',
                        border: `1px solid ${isLightTheme ? '#e9ecef' : '#444'}`,
                        borderRadius: '6px'
                    }}>
                        <h6 style={{ 
                            color: isLightTheme ? '#666' : '#ccc', 
                            margin: '0 0 10px 0',
                            fontSize: '14px',
                            fontWeight: 'bold'
                        }}>
                            COORDINATES
                        </h6>
                        <div style={{ 
                            color: isLightTheme ? '#333' : '#fff',
                            fontSize: '14px',
                            fontFamily: 'monospace'
                        }}>
                            Lat: {location.lat.toFixed(6)}<br/>
                            Lng: {location.lng.toFixed(6)}
                        </div>
                    </div>
                </div>

                {/* Map Button */}
                <div style={{ textAlign: 'center' }}>
                    <button
                        onClick={handleViewMap}
                        style={{
                            padding: '15px 30px',
                            backgroundColor: '#28a745',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '6px',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '10px',
                            margin: '0 auto'
                        }}
                    >
                        📍 View Location on Map
                    </button>
                </div>

                {/* Additional Info */}
                <div style={{
                    marginTop: '30px',
                    padding: '15px',
                    backgroundColor: isLightTheme ? '#e7f3ff' : '#0d2240',
                    border: `1px solid ${isLightTheme ? '#b8daff' : '#1e3d5f'}`,
                    borderRadius: '6px'
                }}>
                    <div style={{
                        color: isLightTheme ? '#004085' : '#87ceeb',
                        fontSize: '14px',
                        textAlign: 'center'
                    }}>
                        <strong>ℹ️ Information:</strong> This is the last recorded drop location for this trailer based on vehicle check records.
                    </div>
                </div>
            </div>

            {/* Map Modal */}
            <LocationMapModal
                show={showMap}
                onHide={() => setShowMap(false)}
                location={{
                    lat: location.lat,
                    lng: location.lng,
                    address: `Trailer ${trailer_reg} drop location`,
                    timestamp: `${drop_date}T${drop_time}`,
                    accuracy: null
                }}
                title={`${trailer_reg} - Last Drop Location`}
            />
        </div>
    );
};

export default TrailerLocationReport;